import { useEffect } from 'react';
import { VideoRenderingStatus } from '../types.ts/story';
import { VIDEOS_RENDERING_STATUS_QUERY } from '../gql/media-gql';
import { useVideoCreatorStore } from '@src/stores-v2/VideoCreatorStoreContext';
import { useDatoQuerySubscription } from '@src/hooks/useDatoQuerySubscription';

export const useQueryVideos = (
  ids: string[],
): {
  status: string;
  error: any;
  data: { allVideos: VideoRenderingStatus[] } | undefined;
} => {
  const { status, error, data } = useDatoQuerySubscription<
    { allVideos: VideoRenderingStatus[] },
    { ids: string[] }
  >({
    query: VIDEOS_RENDERING_STATUS_QUERY,
    variables: { ids },
  });

  return { status, error, data };
};

const VideosQuerySubscriptionComponent = (props: {
  videoIds: string[];
  onDataReceived: (videos: VideoRenderingStatus[]) => void;
  onError: (error: any) => void;
}) => {
  const { videoIds, onDataReceived, onError } = props;
  const { error, data } = useQueryVideos(videoIds);

  useEffect(() => {
    if (error) {
      onError(error);
    } else if (data?.allVideos?.length) {
      onDataReceived(data.allVideos);
    }
  }, [data, error]);

  return <></>;
};

export default VideosQuerySubscriptionComponent;
